<template>
  <div id="app">
    <t-layout>
      <t-header style="height: 60px;position: sticky; top: 0;z-index: 999;">
        <t-head-menu height="60px" style="width:1440px;margin:  0 auto;height: 60px;">
          <template #logo>
            <img src="@/assets/logo/logo.svg" style="width: 116px;height: 40px;margin-left: 20px;">
          </template>
          <template #operations>
            <!-- <t-button class="login-button">登录</t-button> -->
            <t-button class="login-button" @click="handleToCorePlat">前往基础平台</t-button>
          </template>
        </t-head-menu>

      </t-header>
      <t-layout style="background: #f5f5f5;height: 100%;">
        <t-layout style="width: 1440px;margin: 0 auto;">
          <t-aside>
            <navbar></navbar>
          </t-aside>

          <t-layout>
            <t-content>
              <div><router-view :key="$route.fullPath"></router-view></div>
            </t-content>
            <t-footer>
              <div style="height: 100px;padding: 23px 20px 0px 20px;border-bottom: 1px solid #e3e6ea;">
                <t-row>
                  <t-col :span="4">
                    <div>
                      <div class="footer-title">星晟工程数字管理有限公司</div>
                      <div class="footer-value">宁波市高新区创苑路750号软件园D座307室</div>
                    </div>
                  </t-col>
                  <t-col :span="4">
                    <div>
                      <div class="footer-title">联系我们</div>
                      <div class="footer-value">联系方式: 139 5780 8808 177 0688 0700<br>邮箱: 123111878@qq.com</div>
                    </div>
                  </t-col>
                  <t-col :span="4">
                    <div>
                      <div class="footer-title">工作时间</div>
                      <div class="footer-value">周一至周日 09:00-17:00 （节假日除外）</div>
                    </div>

                  </t-col>
                </t-row>
              </div>
              <div style="font-family: 'Regular';height: 41px;line-height: 41px;font-size: 14px;font-weight: 400;">
                Copyright @ 2021-2022 xingsheng. All Rights Reserved
              </div>

            </t-footer>
          </t-layout>

        </t-layout>

      </t-layout>

    </t-layout>
    <t-back-top style="position: flex" :visible-height="200" :duration=200 shape="circle" theme="light"></t-back-top>

    <t-dialog header="积分充值" :visible.sync="visible" width="546px" class="integral-dialog" :footer="false">
      <t-row :gutter="20" style="width: calc(100% + 20px);">
        <t-col :span="4" v-for="item in integralcommodityList" :key="item.id">
          <div class="integralcommodity-item" @click="handlePay(item)" :class="{ 'active': selectedId === item.id }">
            <div class="money">
              <span class="icon">¥</span>
              <span class="text">{{ (item.integralPrice / 100).toFixed(2) }}</span>
            </div>
            <div class="point-number">
              <span class="text">{{ item.integralNumber }}</span>
              <span class="icon">积分</span>
            </div>
          </div>
        </t-col>
      </t-row>
      <div class="integralcommodity-pay">
                <div class="pay-left" v-loading="QRCodeLoading">
                    <img :src="QRCodeUrl" id="qrcodeImage" alt="QR Code"
                        style="width: 150px;position: relative;left: -10px;top: -10px;" v-if="QRCodeUrl">
                    <!-- <div  class="qrcode-placeholder"></div> -->
                    <el-skeleton style="width: 120px" animated v-else>
                        <template slot="template">
                            <el-skeleton-item style="width: 130px; height: 130px;" />
                        </template>
                    </el-skeleton>
                </div>
                <div class="pay-center">
                    <div class="title">请扫码支付</div>
                    <div class="time" v-if="QRCodeUrl">
                        <div class="time-title">剩余时间</div>
                        <el-statistic :value="deadline" time-indices title="" @finish="hilarity" format="mm:ss">
                        </el-statistic>
                    </div>
                    <el-skeleton v-else class="time" animated>
                        <template slot="template">
                            <el-skeleton-item variant="text" style="width: 120px;height: 12px;"></el-skeleton-item>
                        </template>
                    </el-skeleton>
                    <div class="pay-money" v-if="QRCodeUrl">
                        <span class="icon">¥</span>
                        <span class="text">{{ selectedId && (integralcommodityList.find(item => item.id ===
                            selectedId).integralPrice / 100).toFixed(2) }}</span>
                    </div>
                    <el-skeleton v-else class="pay-money" animated>
                        <template slot="template">
                            <el-skeleton-item variant="text" style="width: 80px;height: 28px;"></el-skeleton-item>
                        </template>
                    </el-skeleton>
                    <div class="pay-second-title">
                        支持使用微信扫码支付
                        <el-link type="info">《积分协议》</el-link>
                    </div>
                </div>
                <div class="pay-right">
                    <img src="@/assets/images/point/point-pay-dialog-icon.svg">
                </div>
            </div>
    </t-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import CryptoJS from 'crypto-js'
import QRCode from 'qrcode';
import { setCoreUserId, getCoreUserId } from '@/utils/coreUserId'
import { listIntegralcommodity,cancelWxQRCode,getIntegralcommodityWxQRCode,getWxQRCodeStatus } from '@/api/core'
import { MessagePlugin } from 'tdesign-vue';

export default {
  data() {
    return {
      visible: false,
      integralcommodityList: [],
      QRCodeLoading: false,
      QRCodeUrl: null,
      timer: null,
      QRCodeorderNo: null,
      deadline: Date.now() + 1000 * 60 * 5,
      selectedId: null,//购买积分选择的产品
    }
  },
  components: {
    Navbar
  },
  mounted() {
    // this.getIntegralcommodityList()
    // console.log(window.location.hostname)
    const hostname = window.location.hostname
    const isIPv4 = (host) => /^\d{1,3}(\.\d{1,3}){3}$/.test(host)
    if (hostname === 'localhost' || isIPv4(hostname)) {
      console.log('不需要基础平台用户ID')
    } else {
      if (window.location.href.split('?')[1]?.includes('userId')) {
        const match = window.location.href.match(/[?&]userId=([^&]*)/);
        const userId = match && decodeURIComponent(match[1]);
        console.log('基础平台用户userId', userId)
        console.log('基础平台用户userId解密', this.decrypt(userId, '1234567890123456'))
        setCoreUserId(this.decrypt(userId, '1234567890123456'))
        if (this.hasCoreUserId()) {
          console.log('有基础平台用户Id')
        } else {
          alert('请前往基础平台进行登录进入')
          window.location.href = "https://core.xingsnb.cn"
          return
        }
      } else {
        if (this.hasCoreUserId()) {
          console.log('有基础平台用户Id')
        } else {
          alert('请前往基础平台进行登录进入')
          window.location.href = "https://core.xingsnb.cn"
          return
        }
      }
    }

  },
  methods: {
    decrypt(encryptedData, key) {
      const keyHex = CryptoJS.enc.Utf8.parse(key);
      const decrypted = CryptoJS.AES.decrypt(encryptedData, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return decrypted.toString(CryptoJS.enc.Utf8);
    },
    hasCoreUserId() {
      return getCoreUserId()
    },
    handleToCorePlat() {
      // window.location.href="http://localhost:60/"
      window.open('https://core.xingsnb.cn/indexC/point', "_blank")
    },
    /** 查询积分商品列表 */
    getIntegralcommodityList() {
      listIntegralcommodity({ pageNum: 1, pageSize: 100 }).then(response => {
        this.integralcommodityList = response.data.rows;
      });
    },
    handlePay(item) {
            this.selectedId = item.id
            if (this.QRCodeorderNo) {
                cancelWxQRCode(this.QRCodeorderNo).then(() => {
                    this.QRCodeorderNo = null
                    window.clearInterval(this.timer)
                    this.getPayWxQRCode(item.id)
                })
            } else {
                this.getPayWxQRCode(item.id)
            }
        },
        getPayWxQRCode(id) {
            this.QRCodeLoading = true
            getIntegralcommodityWxQRCode(id).then(res => {
                this.dialogVisible = true
                this.QRCodeorderNo = res.data.orderNo
                QRCode.toDataURL(res.data.codeUrl, (error, url) => {
                    if (error) {
                      console.log(error);
                    } else {
                        this.QRCodeUrl = url;  // 将二维码图像显示在 img 元素中
                        this.QRCodeLoading = false
                        this.timer = setInterval(() => {    // 通过定时器每间隔一会去请求查询微信支付状态（具体参数根据项目需要而定）
                            this.handleQueryWxPayStatus(this.QRCodeorderNo);
                        }, 1000);
                        this.deadline = Date.now() + 1000 * 60 * 5
                    }
                });
            });
        },
        handleQueryWxPayStatus(orderNo) {
            getWxQRCodeStatus(orderNo).then(res => {
                if (res.code == 200) {
                  MessagePlugin.success('支付成功！');
                    this.dialogVisible = false
                    this.QRCodeorderNo = null
                    this.QRCodeUrl = null
                    this.selectedId = null
                    window.clearInterval(this.timer)
                }
            })
        },
        hilarity() {
            MessagePlugin.error('订单超时，请重新下单！');
            this.closeQRCode()

        },
        closeQRCode() {
            if (this.QRCodeorderNo) {
                cancelWxQRCode(this.QRCodeorderNo).then(() => {
                    this.QRCodeorderNo = null
                    this.QRCodeUrl = null
                    this.dialogVisible = false
                    this.selectedId = null
                    // this.getSumPoint()
                })
                window.clearInterval(this.timer)
            } else {
                this.QRCodeorderNo = null
                this.QRCodeUrl = null
                this.dialogVisible = false
                this.selectedId = null
                // this.getSumPoint()
            }

        },
  }
}
</script>


<style lang="less">
#app {
  font-family: font;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

@media only screen and (min-width: 1440px) {

  /* 这里是你的大雨样式 */
  .t-layout__header {
    border-bottom: 1px solid #dadde1;
  }

  .t-head-menu {
    border-bottom: 0;
  }
}

@media only screen and (max-width: 1439px) {
  .t-layout__header {
    border-bottom: 0;

  }

  .t-head-menu {
    border-bottom: 1px solid #dadde1;
  }
}


.t-head-menu .t-menu__operations:not(:empty) {
  margin-right: 20px !important;

  .login-button {
    // width: 82px;
    padding: 0 10px;
    height: 32px !important;
    border-radius: 6px !important;
    opacity: 1;
    border: 1px solid #1c37c3;
    background: linear-gradient(180deg, #5f89f1 0%, #5783f1 56.00000000000001%, #456fec 100%);
  }
}



.t-aside {
  margin-top: 20px;
}

.t-layout {
  background: #f5f5f5 !important;
}

.t-layout__sider {
  margin-top: 20px;
  // border: 1px solid #e3e6ea;
  background: none !important;
}

.t-layout__content {
  margin-top: 20px;
}

.t-layout__footer {
  padding: 0 !important;
  margin-top: 24px;
  border-top: 1px solid #e3e6ea;

  .footer-title {
    height: 21px;
    opacity: 1;
    color: #333333;
    font-size: 16px;
    font-weight: 600;
    font-family: "Black";
    text-align: left;
  }

  .footer-value {
    height: 19px;
    opacity: 0.800000011920929;
    color: #888888;
    font-size: 14px;
    font-weight: 400;
    font-family: "Regular";
    text-align: left;
    margin-top: 10px;

  }
}

.t-back-top {
  width: calc(100% - 2px);
  height: calc(100% - 2px);
}

.integral-dialog {
  .t-dialog {
    padding: 20px !important;
  }

  .t-dialog__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: visible !important;
  }

  .integralcommodity-item {
    height: 110px;
    padding: 10px;
    border-radius: 6px;
    border: 1px solid #EEE;
    margin-bottom: 20px;
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .money {
      color: #2084ff;
      font-family: "PingFang SC";
      display: flex;
      flex-direction: row;
      align-items: center;

      .icon {
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-right: 2px;
      }

      .text {
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }

    .point-number {
      color: #000000;
      font-family: "PingFang SC";
      display: flex;
      flex-direction: row;
      align-items: center;

      .text {
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      .icon {
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 2px;
      }
    }
  }

  .active {
    border-color: #2084FF;

    &::after {
      // background-image: url("../../../assets/images/point/select-icon.svg");
      content: url("./assets/images/point/select-icon.svg");
      position: absolute;
      bottom: -5px;
      right: 0px;
    }
  }

  .integralcommodity-pay {
    flex-shrink: 0;
    border-radius: 8px;
    border: 1px solid #EEE;
    padding: 20px;


    .pay-left {
      border-radius: 4px;
      border: 1px solid #EEE;
      padding: 6px;
      width: 132px;
      height: 132px;
      display: inline-block;
      vertical-align: top;
      overflow: hidden;

      .qrcode-placeholder {
        width: 120px;
        height: 120px;
        background-color: #D9D9D9;
      }
    }

    .pay-center {
      display: inline-block;
      vertical-align: top;
      width: 168px;
      margin-left: 16px;
      text-align: left;

      .title {
        color: #000000;
        font-family: "PingFang SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      .time {
        color: #666666;
        font-family: "PingFang SC";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top: 6px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .time-title {
          display: inline-block;
          vertical-align: top;
        }

        .el-statistic {
          display: inline-block;
          vertical-align: top;
          width: auto;
          color: #666666;
          font-family: "PingFang SC";
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;

          .number {
            font-size: 14px !important;
            color: #666666;
          }
        }
      }

      .pay-money {
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #f5595e;
        margin-top: 13px;
        height: 34px;

        .icon {
          font-size: 16px;
        }

        .text {
          font-size: 24px;
        }
      }

      .pay-second-title {
        color: #000000;
        font-size: 12px;
        margin-top: 8px;

        ::v-deep .el-link {
          font-size: 12px;
        }
      }
    }

    .pay-right {
      display: inline-block;
      vertical-align: bottom;
      margin-left: 22px;
    }
  }
}
</style>
